module.exports = __webpack_public_path__ + "static/media/19.d50d8ea0.mp3";